export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1440w.81187f55.avif";